// extracted by mini-css-extract-plugin
module.exports = {"container":"_1ay_FlIuAB7BPWtAGqO6Vn","subTitle":"_11bo1H8CB6jn7MaBc2EYFG"};